import "../css/Modal.css"
import { useState, useEffect, useContext } from "react";
import UserContext from "../contexts/UserContext";
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";


function NeverLoggedInUsers({ t, setErrorValue, setNeverLoggedIn }) {
    const [users, setUsers] = useState([]);
    const userCtx = useContext(UserContext);
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        fetchNeverLoggedInUsers();
    }, []);

    function fetchNeverLoggedInUsers() {
        setIsLoading(true);
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web", getAll: false }),
        };
        try {
            FetchUtil.fetchAPI("MGetNeverLoggedInUsers", "/Service/UserService/GetNeverLoggedInUsers", requestOptions, getNeverLoggedInUsersSuccess, getNeverLoggedInUsersFail);
        } catch (error) {
            setErrorValue(error.message);
            setNeverLoggedIn(false);
            setIsLoading(false);
        }
    }

    function getNeverLoggedInUsersFail(redirect) {
        setErrorValue(t("error.neverLoggedInUsersNotRetrieved"));
        setNeverLoggedIn(false);
        setIsLoading(false);
    }
    function getNeverLoggedInUsersSuccess(responseData) {
        let neverLoggedInUsersResponse;
        if (responseData) {
            neverLoggedInUsersResponse = responseData.neverLoggedInUsersResponse;
            if (neverLoggedInUsersResponse && neverLoggedInUsersResponse.errorCode === "0") {
                setUsers([...users, ...neverLoggedInUsersResponse.users]);
            } else if (neverLoggedInUsersResponse) {
                setErrorValue(t("error.error") + " " + neverLoggedInUsersResponse.errorMessage);
                setNeverLoggedIn(false);
            }
        }
        setIsLoading(false);
    }
    const handleClose = () => {
        setErrorValue("");
        setNeverLoggedIn(false);
    };
    return (
        <>
            {(userCtx.role === "SiteAdmin") ?
                <div className="modalContainer hide-scrollbar">
                    <div className="row">
                        <div className="col">
                            <h2>{t("header.admin.users.neverLoggedIn")}</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div id="placeholder_1" className="placeholder-pg"></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            {(isLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div id="placeholder_2" className="placeholder-pg"></div>
                        </div>
                    </div>
                    <div className="row" style={{ margin: "0px" }}>
                        <div className="col">
                            <a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div id="placeholder_3" className="placeholder-pg"></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <table className="list-table" role="table">
                                <thead>
                                    <tr role="row">
                                        <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.email")}</th>
                                        <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.name")}</th>
                                        <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.company")}</th>
                                    </tr>
                                </thead>
                                <tbody role="rowgroup">
                                    {users.length > 0 && (
                                        users.map((eachUser, index) => (
                                            <tr key={index}>
                                                <td className={(((index % 2) > 0) ? true : false) ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{eachUser.userId}</td>
                                                <td className={(((index % 2) > 0) ? true : false) ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{eachUser.userName}</td>
                                                <td className={(((index % 2) > 0) ? true : false) ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{eachUser.companyName}</td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                            <div className="row">
                                <div className="col">
                                    <div id="placeholder_4" className="placeholder-pg"></div>
                                </div>
                            </div>
                            <div className="footer">
                                <input
                                    type="button"
                                    name="edit-partner-close"
                                    id="edit-partner-close"
                                    disabled={isLoading}
                                    className="btn btn-secondary btn-block" data-dismiss="modal"
                                    onClick={(e) => handleClose()}
                                     style={{ marginTop: "10px", marginBottom: "10px" }}
                                    value={t("page.close")}
                                ></input>
                            </div>
                        </div>
                    </div>
                </div>
                : null}
        </>
    );
}

export default NeverLoggedInUsers;